export default __webpack_public_path__ + "static/media/Wolf's Legguards of the Grasslands.d2372aa1.jpg";